<template>
    <div>
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-6">
                        <h3>REPORTE FOLIOS DE TRANSBORDADOR</h3>
                    </div>
                    <div class="col-6 text-right">
                        <button class="btn btn-primary btn-icon" @click="cargar_datos"><i class="fas fa-filter"></i> Filtrar</button>
                        <button class="btn btn-success btn-icon" @click="exportar_excel"><i class="fas fa-file-excel"></i> Excel</button>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="col">
                        <table class="table table-bordered">
                            <tr class="background-light">
                                <th>RANGO DE FECHAS</th>

                            </tr>
                            <tr>
                                <td>
                                    <date-picker v-model="fechas" :range="true" format="DD-MM-YYYY" :editable="false" :clearable="true" value-type="YYYY-MM-DD"></date-picker>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>


                <!-- <div class="row">
                    <div class="col">


                    <div class="accordion" id="accordionExample">
                        <div class="card">
                                <div class="card-header background-blue-2" id="headingOne" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <h5 class="mb-0">COLUMNAS TICKET</h5>
                                </div>
                                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                    <div class="card-body">
                                    
                                         <div class="row">
                                            <div class="col">
                                                <div class="table-responsive">
                                                    <table class="table">
                                                        <tr class="thead-skyblue2">
                                                            <th :colspan="columnas.length">
                                                                <label class="margen-1" for="" ><input type="checkbox" id="" value="" v-model="todos" @change="setearTodos"> Todos</label>
                                                            </th>
                                                        </tr>

                                                        <tr>
                                                            <td v-for="col in columnas" :key="col.label">
                                                                <label class="margen-1" for=""><input type="checkbox" id="" value="" v-model="col.show"> {{col.label}}</label>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div>
                                                
                                                


                                            </div>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>


                    </div>
                </div> -->

                <div class="row mt-1" v-show="navieras.length > 0">
                    <div class="col">
                            <div class="tableFixHead" style="width:100%">
                                <table class="table table-bordered">
                                    <thead class="">
                                        <!-- <tr>
                                            
                                            <th class="fixed thead-skyblue2 text-center" v-for="c in columnas" :key="c.label" v-show="c.show">{{c.label}}</th>
                                            <th class="fixed thead-skyblue2 text-center" v-for="n in navieras" :key="n.nombre">{{n.nombre}} (PASADAS)</th>
                                            <th class="fixed thead-skyblue2 text-center" v-for="n in navieras" :key="n.nombre">{{n.nombre}} (TARIFA)</th>
                                        </tr> -->
                                        <tr>
                                            <th class="fixed-1" v-for="c in columnas" :key="c.label" v-show="c.show"></th>
                                            <th :colspan="materias_primas.length+2" class="fixed-1 thead-skyblue2 text-center" v-for="n in navieras" :key="n.id">
                                                {{n.nombre}}
                                            </th>
                                        </tr>

                                        <tr>
                                            <th class="fixed-2 thead-skyblue2 text-center" v-for="c in columnas" :key="c.label" v-show="c.show">{{c.label}}</th>
                                            
                                            <slot v-for="n in navieras">
                                                <th class="text-center thead-skyblue2" :key="`${n.id}C`">
                                                    PASADAS
                                                </th>
                                                <th class="text-center thead-skyblue2" :key="`${n.id}D`">
                                                    TOTAL TARIFAS
                                                </th>
                                                <th class="text-center thead-skyblue2" v-for="(mp,idx) in materias_primas" :key="idx">
                                                    {{mp.nombre}}
                                                </th>
                                            </slot>
                                            <!-- <th class="text-center" v-for="n in navieras" :key="n.id">
                                                {{n.nombre}} | PASADAS
                                            </th>

                                            <th class="text-center" v-for="n in navieras" :key="n.id">
                                                {{n.nombre}} | TARIFA
                                            </th> -->
                                        </tr>

                                    </thead>
                                    <tbody>
                                        <tr v-for="d in datos" :key="d.id" v-bind:class="{'background-red-2':d.marcar_rojo == 1,'background-light':d.seleccionado == 1}">
                                            
                                            <td class="text-center" v-for="c in columnas" :key="c.label" v-show="c.show" @click="d.seleccionado == 1?d.seleccionado= 0:d.seleccionado=1">
                                                



                                                <span v-if="c.tipo == 'number'">
                                                    {{ devuelve_valor(d,c.path,c.tipo)| formatear_miles}}
                                                </span>

                                                <span v-if="c.tipo == 'string' || c.tipo == 'datetime' || c.tipo == 'date' || c.tipo=='time'">
                                                    {{devuelve_valor(d,c.path,c.tipo)}}
                                                </span>

                                                

                                            </td>

                                            <slot v-for="n in navieras" >
                                                <td class="text-center" :key="`${n.id}A`">
                                                    {{devuelve_valor_naviera(n.id,'cantidad_pasadas',d)}}
                                                </td>
                                                <td class="text-center" :key="`${n.id}B`">
                                                    {{devuelve_valor_naviera(n.id,'total_tarifas',d) | formatear_miles}}
                                                </td>
                                                <td v-for="(mp,idx) in materias_primas" :key="idx">
                                                    {{devuelve_valor_mp(d,mp.id,n.id,'total') | formatear_miles}}
                                                </td>
                                            </slot>

                                            <!-- <td class="text-center" v-for="n in navieras" :key="n.id">
                                                {{devuelve_valor_naviera(n.id,'cantidad_pasadas',d)}}
                                            </td>

                                            <td class="text-center" v-for="n in navieras" :key="n.id">
                                                {{devuelve_valor_naviera(n.id,'total_tarifas',d) | formatear_miles}}
                                            </td> -->
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                    </div>
                </div>

                <!-- <div class="row">
                    <div class="col">
                        <table class="table table-bordered">
                            <thead class="thead-blue">
                                <tr>
                                    <th class="text-center">TOTAL PESO INFORMADO (KG)</th>
                                    <th class="text-center">TOTAL PESO RECIBIDO (KG)</th>
                                    <th class="text-center">TOTAL PESO DISTRIBUCIÓN (KG)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="total_resultado">
                                    <td class="text-center">{{total_resultado.total_peso_informado | formatear_miles}}</td>
                                    <td class="text-center">{{total_resultado.total_peso_recibido | formatear_miles}}</td>
                                    <td class="text-center">{{total_resultado.total_distribucion | formatear_miles}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div> -->

                <!-- <pre>{{mes}}</pre>
                <pre>{{anio}}</pre>
                <pre>{{inicio}}</pre>
                <pre>{{fin}}</pre>
                <pre>{{getDates}}</pre> -->
                <!-- <pre>{{fechas}}</pre> -->
                <!-- <pre>{{total_resultado}}</pre> -->
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    data:()=>({
        fechas:[],
        todos:true,
        columnas:[
            //{show:true,label:'Fecha Ticket',tipo:'datetime',path:'fecha_hora_ticket'},
            {show:true,label:'Patente',tipo:'string',path:'patente'},
            {show:true,label:'Total Pasadas',tipo:'number',path:'cantidad_pasadas'},
            {show:true,label:'Total Tarifas',tipo:'number',path:'total_tarifas'},

            /* {show:true,label:'Hora Ticket',tipo:'time',path:'hora_ticket'},
            {show:true,label:'N° Ticket',tipo:'string',path:'codigo_ticket'},
            {show:true,label:'Fecha Guía (Salida Origen)',tipo:'datetime',path:'fecha_guia'},
            {show:true,label:'N° Guía',tipo:'string',path:'numero_guia'},
            {show:true,label:'Declaracion Jurada',tipo:'string',path:'declaracion_jurada'},
            {show:true,label:'CAM',tipo:'string',path:'cam'},
            {show:true,label:'Empresa',tipo:'string',path:'empresa'},
            {show:true,label:'Sucursal',tipo:'string',path:'sucursal'},
            {show:true,label:'Materia Prima',tipo:'string',path:'materia_prima'},
            {show:true,label:'Especie',tipo:'string',path:'especie'},
            {show:true,label:'Producto',tipo:'string',path:'producto'},
            {show:true,label:'Restriccion',tipo:'string',path:'restricciones'},
            {show:true,label:'Patente',tipo:'string',path:'patente'},
            {show:true,label:'Tiempo Camion en Planta',tipo:'string',path:'tiempo_camion_planta'},
            {show:true,label:'Cantidad Bins',tipo:'number',path:'cantidad_bins'},
            {show:true,label:'Peso Informado Guía (kg)',tipo:'number',path:'peso_informado_guia'},
            {show:true,label:'Peso Recibido Guía (Romana) (Kg)',tipo:'number',path:'peso_real_guia'},
            {show:true,label:'Destino Distribución',tipo:'string',path:'destino_distribucion'},
            {show:true,label:'Peso Distribucion (Kg)',tipo:'number',path:'peso_real_distribucion'}, */

        ],

        datos:[],
        navieras:[],
        url_excel:null,
        cabeceritas : '',
        materias_primas:[]
    }),
    mounted(){
        this.cargar_navieras();
    },
    methods:{


        async cargar_navieras(){
          await this.axios.get(`${this.api}/empresas?tipo_empresa_ids=3`,this.cabeceras_json).then((res)=>{
            this.navieras = res.data.data.data;
            console.log('res',res.data.data);
          }).catch((e)=>{
            console.log(e);
          });
          this.cargar_materias_primas();
        },

        async cargar_materias_primas(){
          await this.axios.get(`${this.api}/mps_tipo?limit=999999999`,this.cabeceras_json,).then(res=>{
                this.materias_primas = res.data.data.data;
            }).catch(e=>{
                //console.log(e);
            });
        },

        async cargar_datos(){
                let body = {
                    columnas:this.columnas.filter(c => c.show == true).map((c)=>{
                        return {
                            cabecera:c.label,
                            path:c.path,
                            tipo:c.tipo
                        }
                    }),
                }
                /* if(this.empresas_id.length > 0){
                    body.empresas_id = this.empresas_id;
                } */
                
                if(this.fechas[0] != null && this.fechas[0] != undefined){
                    body.desde = this.fechas[0];
                    body.hasta = this.fechas[1];
                }
                await this.axios.post(`${this.api}/reportes/folios_transbordadores`,body,this.cabeceras_json).then(res=>{
                    console.log(res.data.data);
                    this.datos = res.data.data.data;
                    this.navieras = res.data.data.navieras;
                    //this.total_resultado = res.data.data.total;
                    this.url_excel = res.data.data.url_excel;
                    console.log('url_excel',this.url_excel);
                }).catch(e=>{
                    //console.log(e);
                });
            //}
            
        },

        async exportar_excel(){
            window.open(this.url_excel, '_blank');
        },

        devuelve_valor(item,path,tipo_dato){
          let keys = path.split('.');
          let valor = item;
          keys.forEach(k => {
                for (var key in valor) {
                  if(key == k){
                    valor = valor[key];
                  }
                }
                  
          });
          if(tipo_dato == 'datetime'){
            valor = this.$options.filters.fecha_hora(valor);
          }
          if(tipo_dato == 'date'){
            valor = this.$options.filters.fecha(valor);
          }
          if(tipo_dato == 'time'){
            valor = this.$options.filters.hora(valor);
          }
          return valor;
        },

        devuelve_valor_naviera(id,path,item){
            let i = item.resumen_navieras.find(n => n.id == id);
            let valor = i[path];
            return valor;
        },

        devuelve_valor_mp(item,mp_id,naviera_id,path){
            let nav = item.resumen_navieras.find(n=>n.id == naviera_id); 
            let valor = 0;
            if(nav.resumen_mps){
                let i = nav.resumen_mps.find(mp => mp.id == mp_id);
                valor = i[path]
            }
            return valor;
        },

        setearTodos(){
            this.columnas.forEach(c => {
                c.show = this.todos;
            });
        },

        
    },
    computed:{

        ...mapState(['api','api_public','cabeceras_json','token'])
    }
}
</script>
<style>
.tableFixHead          { overflow: auto; height: 600px; border: 1px solid rgb(212, 212, 212);}
/*.tableFixHead thead th { position: sticky; top: 0; z-index: 100; }*/

.fixed{
    position: sticky; top: 0; z-index: 100;
}

/* Just common table stuff. Really. */
table  { border-collapse: collapse; width: 100%; }
th, td { padding: 8px 16px; }
/*th     { background:#427391; color:#fff }*/
.margen-1{
    margin: 0em 0.5em;
}

</style>